import type { FaireProductEntity } from "../../entity_types/product";

export const p_quha3r2v6m: FaireProductEntity = {
  token: "p_quha3r2v6m",
  type: "product",
  name: "Stainless Steel Gold Evil Eyes CZ Huggie Hoops SSERG04",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/5012b6174cb6fb1c90bc8046b661522147e23abb0d3c693b57dd3f69bf52724f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/01daef2328544e880ef7bbe853ee5f1801145b5b6e897cca846a382b5e8291c9.jpeg",
    "https://cdn.faire.com/fastly/a5f007271461dfc597ad13f27205ac8408352bed26e36e353f0217002867200a.jpeg",
    "https://cdn.faire.com/fastly/ea391d13e6eb40846945407846a26dc61268253ff6ba14095d1772f62a3b1f4c.jpeg",
    "https://cdn.faire.com/fastly/21ef7ab5c33f588fdb09803f1fa613b2f6fe95e7c160873970ebca2de0cae3f7.jpeg",
  ],
  priceDollars: 31,
  description:
    "SStainless Steel Gold Evil Eyes huggie hoops, CZ Detail Small huggie hoops, Earring Hoops, Huggies, Earrings, SSERG04\nMaterial: 18k PVD plated over Stainless Steel, CZ Stones, Water Proof, Tarnish Proof, Hypoallergenic\nLead, nickel and cadmium free\nMeasurement: 10mm\nColor: Gold\nBulk discount is available at drop down menu\nShip from Los Angeles",
  tags: [],
  msrpDollars: 62.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:58.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
